import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import PasswordResetPage from './pages/PasswordResetPage';
import MeasurementsPage from './pages/MeasurementsPage';
import MeasurementCreationOptionsPage from './pages/MeasurementCreationOptionsPage';
import CreateMeasurementPage from './pages/CreateMeasurementPage';
import CreateMeasurementTagPage from './pages/CreateMeasurementTagPage';
import MeasurementDetailsPage from './pages/MeasurementDetailsPage';
import ProtectedRoute from './components/ProtectedRoute';
import { WebPubSubProvider } from './contexts/WebPubSubContext';
import './App.css';

const App: React.FC = () => {
  return (
    <Router>
      <WebPubSubProvider>
      <div className="App">
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/password-reset" element={<PasswordResetPage />} />
          <Route 
            path="/dashboard" 
            element={<Navigate to="/measurements" replace />}
          />
          <Route 
            path="/measurements" 
            element={
              <ProtectedRoute>
                <MeasurementsPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/create-measurement" 
            element={
              <ProtectedRoute>
                <MeasurementCreationOptionsPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/create-measurement-eoc" 
            element={
              <ProtectedRoute>
                <CreateMeasurementPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/create-measurement-tag" 
            element={
              <ProtectedRoute>
                <CreateMeasurementTagPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/measurements/:id" 
            element={
              <ProtectedRoute>
                <MeasurementDetailsPage />
              </ProtectedRoute>
            } 
          />
          <Route path="/" element={<Navigate to="/login" replace />} />
        </Routes>
      </div>
      </WebPubSubProvider>
    </Router>
  );
};

export default App;